import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getPositionListing = async (payload) => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.positions.option();
		const keyword = (payload?.keyword || "").toLowerCase();
		const content = res.map(({ label, ...o }) => ({ label, value: label, ...o })).filter((o) => o.label?.toLowerCase().includes(keyword));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getPositionListing;
